import * as z from 'zod';
import { getCookie, setCookie } from '../utils';
import { useEffect, useState } from 'preact/hooks';
import { useConfig } from '../providers/ConfigProvider';

const COOKIE_NAME = 'sa_widget_session_id';

const sessionEvent = z.object({
  sessionId: z.string(),
});

export const useWidgetCookie = () => {
  const [initialised, setInitialised] = useState(false);
  const { config } = useConfig();

  useEffect(() => {
    function eventListener(event: MessageEvent) {
      if (process.env.WEBSITE_DOMAIN !== event.origin || event.source === window) {
        return;
      }
      try {
        if (typeof event.data !== 'string') {
          return;
        }
        const eventData = JSON.parse(event.data);
        const cookieData = sessionEvent.parse(eventData);
        let sessionId = getCookie(COOKIE_NAME);

        // If we don't have a session id or we have a matching id, create/update the cookie
        if (!sessionId || cookieData.sessionId === sessionId) {
          setCookie(COOKIE_NAME, cookieData.sessionId, config.cookieDuration);
        }

        // If we have a session id and it isn't a match, send back the id
        const payload = { 'sessionId': sessionId }
        event.source?.postMessage(JSON.stringify(payload), {targetOrigin: event.origin});

        setInitialised(true);
      } catch(e) {
        console.error('Error parsing event data:', e);
      }
    }
    window.addEventListener("message", eventListener);
    return () => {
      window.removeEventListener("message", eventListener);
    }
  }, []);

  return { initialised };
}

